import { api } from "../api";
import { Currency, GetAllCurrenciesResponse } from "./interface";

interface BackendCurrency {
  code: string;
  name: string;
  symbol: string;
  type: "CRYPTO" | "FIAT";
  decimals: number;
  is_active: boolean;
  icon: string | null;
  sort_order: number;
}

function toLegacy(c: BackendCurrency, rate = 0): Currency {
  return {
    id: c.code.charCodeAt(0) * 31 + c.code.charCodeAt(1 % c.code.length),
    title: c.name,
    symbol: c.code,
    icon: c.icon ?? "",
    currency_type: c.type === "FIAT" ? "CASH" : "CRYPTO",
    rate,
  };
}

let currenciesCache: BackendCurrency[] | null = null;

async function fetchCurrenciesRaw(): Promise<BackendCurrency[]> {
  if (currenciesCache) return currenciesCache;
  const res = await api.get<BackendCurrency[]>("/currencies");
  currenciesCache = res.data;
  return currenciesCache;
}

export async function getAllCurrencies(): Promise<GetAllCurrenciesResponse> {
  const raw = await fetchCurrenciesRaw();
  return raw.map((c) => toLegacy(c));
}

export function invalidateCurrenciesCache() {
  currenciesCache = null;
}
